/**
 * input tag onkeypress callback method
 * 숫자만 입력되도록 함
 */
export function onKeyPressForOnlyDigit(event){
    event = (event) ? event : window.event;
    var charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        event.preventDefault()
    }
    else {
        return true
    }
}